import { ReactNode } from 'react';

import { css } from '@compiled/react';

const rootCss = css({
	display: 'flex',
	width: 152,
	minHeight: 104,
	padding: '10px 8px 12px 8px',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'space-between',
	flexShrink: 0,
	borderRadius: 20,
	border: '#8C8F97',
	background: '#F8F8F8',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.tile-icon-hovered': {
		display: 'none',
	},

	':hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'.tile-icon': {
			display: 'none',
		},

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'.tile-icon-hovered': {
			display: 'block',
		},
	},
	boxShadow: '0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)',
});

const rootInactiveCss = css({
	// FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
	// eslint-disable-next-line local/ensure-wac-token-usage
	border: 'solid 1px #F8F8F8',
});

const rootActiveCss = css({
	// FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
	// eslint-disable-next-line local/ensure-wac-token-usage
	border: 'solid 1px #8C8F97',
});

const buttonResetStyle = css({
	border: 'none',
	background: 'transparent',
	padding: '0',

	':hover': {
		cursor: 'pointer',
	},
});

const imageContainerCss = css({
	width: 40,
	height: 40,
});

const labelCss = css({
	// FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
	// eslint-disable-next-line local/ensure-wac-token-usage
	color: '#101214',
	textAlign: 'center',
	fontSize: 16,
	fontStyle: 'normal',
	fontWeight: 400,
	lineHeight: '16px',
	flexGrow: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
});

const labelActiveCss = css({
	fontWeight: 700,
});

export interface TileProps {
	icon: ReactNode;
	iconHovered?: ReactNode;
	label: ReactNode;
	isActive?: boolean;
	onClick: () => void;
	onMouseEnter?: () => void;
	onFocus?: () => void;
	href?: string;
}

export const Tile = (props: TileProps) => {
	const ElementType = props.href ? 'a' : 'button';
	return (
		<ElementType
			href={props.href}
			onClick={(e) => {
				e.preventDefault();
				props.onClick();
			}}
			onMouseEnter={props.onMouseEnter}
			onFocus={props.onFocus}
			css={[buttonResetStyle, rootCss, props.isActive ? rootActiveCss : rootInactiveCss]}
		>
			<div css={imageContainerCss}>
				<div className="tile-icon">{props.icon}</div>
				<div className="tile-icon-hovered">
					{props.iconHovered !== undefined && !props.isActive ? props.iconHovered : props.icon}
				</div>
			</div>

			<span css={[labelCss, props.isActive && labelActiveCss]}>{props.label}</span>
		</ElementType>
	);
};
